import * as React from 'react';
import EDBox from '../../../../../../BaseComponents/EDBox/EDBox';
import EDTypography from '../../../../../../BaseComponents/Typography/EDTypography';

const isEmpty = (value: any): boolean =>
  value === null || value === undefined || value === '';

interface IProps {
  value: any;
  placeholder: string;
}

export const PlaceholderCell: React.FC<React.PropsWithChildren<IProps>> = ({
  value,
  placeholder,
}) => (
  <EDBox sx={{ display: 'flex', height: '100%', alignItems: 'center' }}>
    <EDTypography
      variant="body1"
      sx={{
        color: isEmpty(value) ? 'text.disabled' : 'inherit',
        fontStyle: isEmpty(value) ? 'italic' : undefined,
      }}
    >
      {isEmpty(value) ? placeholder : value}
    </EDTypography>
  </EDBox>
);
